import { Search } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export function HeaderSearch() {
  const [value, setValue] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const focusSearch = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLocaleLowerCase() === "k") {
        event.preventDefault();
        inputRef.current?.focus();
      }
    };
    window.addEventListener("keydown", focusSearch);
    return () => window.removeEventListener("keydown", focusSearch);
  }, []);

  const submit = () => {
    const term = value.trim();
    void navigate(term ? `/app/search?q=${encodeURIComponent(term)}` : "/app/search");
  };

  return (
    <form
      className="relative hidden w-[min(26rem,50vw)] items-center sm:flex"
      role="search"
      onSubmit={(event) => {
        event.preventDefault();
        submit();
      }}
    >
      <Search
        className="pointer-events-none absolute left-3 size-4 text-slate-400"
        aria-hidden="true"
      />
      <input
        ref={inputRef}
        type="search"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        onFocus={() => {
          if (!value) void navigate("/app/search");
        }}
        placeholder="Search your notes"
        aria-label="Search your notes"
        className="h-10 w-full rounded-xl border border-slate-200 bg-slate-50 py-2 pl-9 pr-14 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
      />
      <kbd className="pointer-events-none absolute right-3 rounded border border-slate-200 bg-white px-1.5 py-0.5 text-[10px] text-slate-400">
        ⌘ K
      </kbd>
    </form>
  );
}
